import React from "react";
import "../style/home.scss";
import "../style/global.scss";
import calendarIcon from "../assets/logoIcons/calendarIcon.svg";
import ScrollTop from "./subComponents/ScrollToTop";
import homeData from "../store/dec2023/home.json";
import Social from "./Social";
import { Box, Button, Typography, Icon } from "@mui/material";
import aboutData from "../store/dec2023/about.json";

// import { useMediaQuery } from "react-responsive";

const Home = ({ theme }) => {
  // const isTabletOrMobile = useMediaQuery({ query: "(max-width: 515px)" });

  return (
    <Box
      className="homeLayout"
      id="home"
      sx={{
        height: {
          md: "max(100vh, 92rem)",
          xxl: "fit-content",
        },
        maxHeight: {
          md: "100rem",
        },
      }}
    >
      <ScrollTop theme={theme} />
      <Box className="d-flex flex-column justify-content-center sectionMaxWidth">
      <Social theme={theme} />
        <Box className="d-flex justify-content-center">
          <Typography
            className="eventName text-capitalize text-center"
            sx={{
              color: theme.colors.text.primary,
              // marginTop: {
              //   xs: "2rem",
              //   mmb: "5rem",
              // },
              fontSize: {
                xs: "4.5rem",
                md: "8rem",
                //lg: "clamp(10rem, calc(4rem + ((1vw - 0.52rem) * 3.4091)), 7rem)",
              },
            }}
          >
            {/* {homeData.eventName} */}
            M365 Saturday Bangalore 2025
            <br />
            
          </Typography>
        </Box>

        <Box
          className="d-flex justify-content-center align-items-center"
          sx={{
            background: theme.colors.bg.eventDate,
            marginTop: {
              xs: "2.5rem",
              mmb: "6.5rem",
            },
            marginInline: "auto",
            borderRadius: "10px",
            paddingInline: "3rem",
            minWidth: "20rem",
            aspectRatio: "2/0.6",
            // borderRadius: "2.5rem",
          }}
        >
          <Box
            sx={{
              paddingRight: "2rem",
            }}
          >
            <Icon
              component="img"
              sx={{
                fontSize: {
                  xs: "2rem",
                  mmb: "3.5rem",
                },
              }}
              src={calendarIcon}
              alt="calendar icon"
            />
          </Box>
          <Box>
            <Typography
              className="eventDate text-uppercase text-center"
              sx={{
                color: theme.colors.text.primary,
                fontWeight: "600",
                width: "max-content",
                fontSize: {
                  xs: "2rem",
                  mmb: "3.5rem",
                },
              }}
            >
              {homeData.eventDate}
            </Typography>
          </Box>
        </Box>
        <Box
          className="d-flex flex-column justify-content-center align-items-center"
          sx={{
            marginTop: {
              xs: "2rem",
              mmb: "4rem",
            },
          }}
        >
          <Typography
            className="eventType text-capitalize text-center letterSpacing-4"
            sx={{
              color: theme.colors.text.primary,
              fontSize: {
                xs: "2.5rem",
              },
            }}
          >
            {homeData.eventType}
          </Typography>
          <Typography
            className="text-center letterSpacing-4"
            sx={{
              color: theme.colors.text.primary,
              fontWeight: "500",
              fontSize: {
                xs: "1.8rem",
              },
              marginTop:  "2rem"
             
            }}
          >
            Microsoft Luxor North Tower, <br></br>
            Bagmane Capital Campus, Bengaluru
          </Typography>
          {/* <a href={aboutData.communityLink} target="_blank" rel="noreferrer"> */}
            <Typography
              className="eventOrg text-capitalize text-center  letterSpacing-4"
              sx={{
                color: theme.colors.text.primary,
                maxWidth: {
                  xs: "30rem",
                  md: "100%",
                },
                lineHeight: "2rem !important",
                fontSize: {
                  xs: "2.8rem",
                  // mmb: "clamp(2.3rem, calc(2.3rem + ((1vw - 0.52rem) * 0.7955)), 3rem)",
                },
                marginTop: {
                  xs: "4rem",
                  mmb: "5rem",
                },
              }}
            >
              {homeData.orgGroup}
            </Typography>
          {/* </a> */}
          <Typography
            className="text-center letterSpacing-4"
            sx={{
              color: theme.colors.text.primary,
              fontWeight: "500",
              fontSize: {
                xs: "1.8rem",
              },
              marginTop: {
                xs: "3rem",
              },
            }}
          >
            {/* Proudly Presents */}
          </Typography>

        </Box>
        <Box className="justify-content-center">
          <Box
            sx={{
              paddingBottom: {
                xs: "5rem",
              },
              marginTop: {
                xs: "3.5rem",
                mmb: "1rem",
              },
            }}
          >
            <Button
              className="eventButton"
              href={homeData.eventRegLink}
              target={homeData.eventRegLink[0] == "#" ? "_self" : "_blank"}
              sx={{
                color: theme.colors.text.primary,
                fontSize: theme.fontSize.eventButton,
                background: theme.colors.bg.button,
                scale: {
                  xs: "0.7",
                  mmb: "1.2",
                },
                ":hover": {
                  color: theme.colors.text.primary,
                  cursor: "pointer",
                },
              }}
              variant="contained"
              alt="Register Now"
              aria-label="Register Now"
            >
              {homeData.eventButton}
            </Button>

          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default Home;
